const NbsTransactionKeys = {
  TITLE: "title",
  ID_TYPE: "idType",
  USER_ID: "userId",
  CHARGE_CODE: "chargeCode",
  APP_ID: "appId",
  TRANSACTION_DATE: "transactionDate",
  TRANSACTION_ID: "transactionId",
  TRANS_TYPE: "transType",
  PAYMENT_STATUS: "paymentStatus",
  REMARKS1: "remarks1",
  REMARKS2: "remarks2",
  REMARKS3: "remarks3",
  REMARKS4: "remarks4",
  REMARKS5: "remarks5",
  REMARKS6: "remarks6",
  MODULE: "module",
  MSG_FUNCTION: "msgFunction",
  BILL_IND: "billInd",
  QUANTITY: "quantity"
}

export default NbsTransactionKeys
